import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = ["onUpdate:modelValue"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bs5_base_label = _resolveComponent("bs5-base-label")!
  const _component_bs5_base_input = _resolveComponent("bs5-base-input")!
  const _component_bs5_cancel_button = _resolveComponent("bs5-cancel-button")!
  const _component_bs5_save_button = _resolveComponent("bs5-save-button")!
  const _component_bs5_base_modal = _resolveComponent("bs5-base-modal")!

  return (_openBlock(), _createBlock(_component_bs5_base_modal, {
    title: "Generate License",
    visible: _ctx.visible,
    onClose: _ctx.closeModal
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.generateLicense && _ctx.generateLicense(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_bs5_base_label, { for: "licenceRequest" }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createTextVNode("Licence Request File")
            ])),
            _: 1
          }),
          _createElementVNode("input", {
            id: "licenceRequest",
            type: "file",
            class: "form-control",
            onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleFileUpload && _ctx.handleFileUpload(...args)))
          }, null, 32)
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_bs5_base_label, { for: "validTo" }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode("Valid To")
            ])),
            _: 1
          }),
          _createVNode(_component_bs5_base_input, {
            id: "validTo",
            type: "date",
            modelValue: _ctx.license.validTo,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.license.validTo) = $event)),
            required: ""
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_bs5_base_label, null, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode("Features")
            ])),
            _: 1
          }),
          _createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableFeatures, (label, key) => {
              return (_openBlock(), _createElementBlock("label", {
                key: key,
                class: "form-check"
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "form-check-input",
                  "onUpdate:modelValue": ($event: any) => ((_ctx.license[key]) = $event)
                }, null, 8, _hoisted_4), [
                  [_vModelCheckbox, _ctx.license[key]]
                ]),
                _createTextVNode(" " + _toDisplayString(label), 1)
              ]))
            }), 128))
          ])
        ])
      ], 32)
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_bs5_cancel_button, { onClick: _ctx.closeModal }, null, 8, ["onClick"]),
      _createVNode(_component_bs5_save_button, {
        loading: _ctx.saving,
        onClick: _ctx.generateLicense
      }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [
          _createTextVNode("Generate")
        ])),
        _: 1
      }, 8, ["loading", "onClick"])
    ]),
    _: 1
  }, 8, ["visible", "onClose"]))
}